module.exports = __webpack_public_path__ + "4a25a31f56beff05157809624418b31f.svg";